/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `DropoffHasEquipment.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { DropoffHasEquipment } from "./DropoffHasEquipment";

import { Dropoff } from "./Dropoff";
import { Equipment } from "./Equipment";

export abstract class DropoffHasEquipmentModel {
    id: number;
    createdAt: Dayjs;
    dropoffId: number;
    equipmentId: number;
    updatedAt: Dayjs;
    dropoff: Dropoff | null | undefined;
    equipment: Equipment | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        createdAt: Dayjs,
        dropoffId: number,
        equipmentId: number,
        updatedAt: Dayjs,
        dropoff: Dropoff | null | undefined,
        equipment: Equipment | null | undefined
    ) {
        this.id = id;
        this.createdAt = createdAt;
        this.dropoffId = dropoffId;
        this.equipmentId = equipmentId;
        this.updatedAt = updatedAt;
        this.dropoff = dropoff;
        this.equipment = equipment;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): DropoffHasEquipment {
        const newObject = new DropoffHasEquipment(
            json["id"],
            dayjs(json["created_at"]).tz(timezone),
            json["dropoff_id"],
            json["equipment_id"],
            dayjs(json["updated_at"]).tz(timezone),
            json["dropoff"] == null ? json["dropoff"] : Dropoff.fromApiObject(json["dropoff"], timezone),
            json["equipment"] == null ? json["equipment"] : Equipment.fromApiObject(json["equipment"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(visited = new Set<any>()): any {
        if (visited.has(this)) {
            // Return null, undefined, or primary key to break the cycle
            return undefined;
        }
        visited.add(this);

        return {
            id: this.id,
            created_at: this.createdAt,
            dropoff_id: this.dropoffId,
            equipment_id: this.equipmentId,
            updated_at: this.updatedAt,
            dropoff_attributes: this.dropoff?.toApiObject(visited),
            equipment_attributes: this.equipment?.toApiObject(visited),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): DropoffHasEquipment {
        const clone = Object.create(this) as DropoffHasEquipment;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
